import { connect } from 'react-redux'
import ListComponent from './component'
import { AppState } from 'stores/index'
import { mapActiveMunicipality } from 'components/map/actions'
import { Municipality } from 'types/Municipality'
import { Dispatch } from 'redux'
import { flipSortOrder, showLessLines, showMoreLines } from './actions'
import { createSelector } from 'reselect'

const valuesByMunicipalitySelector = (state: AppState) =>
  state.valuesByMunicipality
const filterSelector = (state: AppState) => state.filter
const extentsSelector = (state: AppState) => state.extents
const sortedListSelector = createSelector(
  valuesByMunicipalitySelector,
  filterSelector,
  (map, filter) => {
    const sortedList: Municipality[] = Array.from(map.values())
    sortedList.sort((a: Municipality, b: Municipality) => {
      if (filter.isSortedAscending) {
        return a.Rank - b.Rank
      }
      return b.Rank - a.Rank
    })

    return sortedList.slice(0, filter.numberOfResults)
  }
)

function mapStateToProps(state: AppState) {
  return {
    list: sortedListSelector(state),
    isSortedAscending: filterSelector(state).isSortedAscending,
    currentExtents: extentsSelector(state)
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setActiveMunicipalityHandler: (id: string) => {
      dispatch(mapActiveMunicipality(id))
    },
    onIncreaseShownLines: (amount: number) => {
      dispatch(showMoreLines(amount))
    },
    onDecreaseShownLines: (amount: number) => {
      dispatch(showLessLines(amount))
    },
    onFlipSortOrder: () => {
      dispatch(flipSortOrder())
    }
  }
}

export const List = connect(
  mapStateToProps,
  mapDispatchToProps
)(ListComponent)

export default List
